export const outcomeOptions = [
	'Em acompanhamento',
	'Encaminhamento de plano de cuidados',
	'Alta clínica',
	'Alta a pedido',
	'Encaminhamento especialista',
	'Encaminhamento emergencial',
];
